<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-cash</v-icon>
                <p style="color: white;">Alta Negociación</p>

            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" md="6">
                            <v-col cols="12" md="5">
                                <h4 style="color :#2196f3">Vamos a: </h4>
                                <v-radio-group v-model="datos.tipoNegociacion" :rules="ruleradios"
                                    style="margin: -1px; margin-left: 15px;">
                                    <v-radio label="Pagar" value="1"></v-radio>
                                    <v-radio label="Recuperar" value="2"></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-divider class="mt-1"></v-divider>
                            <div v-if="datos.responsabilidadname != ''">
                                <div class="mt-2">
                                    <span style="font-size:16px">Responsabilidad por parte de conformidad al criterio
                                        del ajustador, el responsable es:</span>
                                    <v-radio-group v-model="datos.responsabilidad"
                                        style="margin: -1px; margin-left: 15px;">
                                        <v-radio :label="datos.responsabilidadname" value="1"></v-radio>
                                    </v-radio-group>
                                </div>
                                <v-divider class="mt-1"></v-divider>
                            </div>

                            <div class="mt-2">
                                <span style="font-size:16px">Estimado de daños NA:</span>
                                <p class="type-text-style">{{ datos.montoestimadodanos }}</p>
                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-2">
                                <span style="font-weight: bold;">Monto de Negociación:</span>
                                <v-text-field v-model="datos.montoneg" outlined dense :rules="rulesInputsNumber"
                                    @keypress="ruleMoney($event, datos.montoneg)"></v-text-field>
                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-2">
                                <span style="font-weight: bold;">Responsabilidad de acuerdo con el documento
                                    soporte:</span>
                                <v-select outlined dense :items="responsabilidadArray"
                                    v-model="datos.responsabilidadSelected" item-text="label" item-value="value"
                                    placeholder="Seleccione Responsabilidad" :rules="ruleSelect">

                                </v-select>
                            </div>

                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-2">
                                <span style="font-weight: bold;">Monto de acuerdo con el documento soporte:</span>
                                <v-text-field v-model="datos.montoacuerdo" outlined dense :rules="rulesInputsNumber"
                                    @keypress="ruleMoney($event, datos.montoacuerdo)"></v-text-field>
                            </div>

                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-2">
                                <span style="font-weight: bold;">Fecha de negociación:</span>
                                <v-dialog ref="dialog" outlined v-model="modal"
                                    :return-value.sync="datos.fechanegociacion" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="date-align-center">
                                            <v-text-field v-model="fechaNeg" label="" readonly :rules="rulestextfechas"
                                                outlined dense v-bind="attrs" v-on="on"></v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="datos.fechanegociacion" locale="es-mx" :max="maxDate"
                                        :min="minDate" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="modal = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary" @click="$refs.dialog.save(datos.fechanegociacion)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-2">

                                <span style="font-weight: bold;">Observaciones</span>
                                <v-textarea @input="uppercase('observaciones')"
                                    v-on:blur="datos.observaciones = datos.observaciones != null ? datos.observaciones.trim() : null"
                                    :counter="$store.state.maxLengthComentarios"
                                    :maxlength="$store.state.maxLengthComentarios" :rules="rulestextarea" outlined
                                    rows="3" v-model="datos.observaciones"></v-textarea>
                            </div>


                        </v-col>
                    </v-row>


                    <v-col md="12">
                        <v-row justify="center">
                            <v-btn dark class="ma-2" color="primary" title="Guardar" @click="guardar()"
                                :disabled="disabledSave">
                                <span style='color: white;'>Guardar</span>
                            </v-btn>
                            <v-btn dark class="ma-2" color="#B0BEC5" title="Limpiar" @click="limpiar()"
                                :disabled="disabledSave">
                                <span style='color: white;'>Limpiar</span>
                            </v-btn>
                            <v-btn dark class="ma-2" color="#FF4081" title="Cancelar" @click="cancelar()"
                                :disabled="disabledSave">
                                <span style='color: white;'>Cancelar</span>
                            </v-btn>
                        </v-row>
                    </v-col>


                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>




<script>
import Reporte from "@/services/ExpJur/ExpJur.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import moment from 'moment';
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
export default {
    title() {
        return this.$route.meta.title
    },
    data() {
        return {
            disabledSave: false,
            validForm: true,
            maxDate: '',
            minDate: '',
            fechaNeg: '',
            modal: false,
            validation: {
                errortipoNegociacion: ''
            },
            ruleradios: [v => !!v || 'Seleccione una opción'],
            rulestextfechas: [v => !!v || 'Campo requerido'],
            rulestextarea: [//v => !!v || 'Campo requerido',
                v => {
                    if (v == null || v == '') {
                        return 'Campo requerido'
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                        }
                        else
                            return true
                    }
                },
            ],
            responsabilidadSelected: null,
            montoacuerdo: null,
            fechatoday: '',
            datos: {
                tipoNegociacion: null,
                responsabilidad: '1',
                responsabilidadname: '',
                montoestimadodanos: '',
                montoneg: null,
                responsabilidadSelected: null,
                montoacuerdo: null,
                fechanegociacion: '',
                observaciones: null
            },
            responsabilidadArray: [
                {
                    value: 1,
                    label: 'Informe'
                },
                {
                    value: 2,
                    label: 'Favorable'
                },
                {
                    value: 3,
                    label: 'Contrario'
                },
                {
                    value: 4,
                    label: 'Corresponsabilidad'
                }
            ],
            validaConclusion: false,
            ruleSelect: [(v) => !!v || "Campo requerido"],
            rulesInputsNumber: [(v) => {
                if (v == null || v == '') {
                    return 'Inserte un valor valido';
                }
                else if (v.length > 11) {
                    return 'Inserte un valor valido';
                }
                else {
                    if (v < 100) {
                        return 'Inserte un valor valido';
                    }
                    else
                        return new RegExp('^[0-9]+(\.[0-9]{1,2})?$').test(v) || "Inserte un valor valido"
                }
                return true
            }],
            push: 0,
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
                d3id: 0
            },
        }
    },
    watch: {
        'datos.fechanegociacion'(val) {
            this.fechaNeg = val;
        },
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        async guardar() {
            this.disabledSave = true;
            this.$refs.form.validate();
            if (this.$refs.form.validate()) {
                this.$swal({
                    position: 'center',
                    title: 'Guardando Negociación ...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                await Reporte.insertarNegociacion(this).then(response => {

                    setTimeout(() => {
                        this.$swal.close();
                        if (response) {
                            this.updateTable = false;
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se guardó correctamente la Negociación',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.cancelar();
                                }
                            });
                            setTimeout(() => {
                                this.$swal.close();
                                this.cancelar();
                            }, 3000);

                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Hubo un error al guardar la Negociación, Favor de avisar a Desarrollo',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                        }

                    }, 2000);



                });


            }
            else {
                this.disabledSave = false;
            }
        },
        limpiar() {
            this.datos.tipoNegociacion = null;
            this.datos.montoneg = null;
            this.datos.responsabilidadSelected = null;
            this.datos.montoacuerdo = null;
            if (this.responsabilidadSelected != 0) {
                const resp = this.responsabilidadSelected;
                this.datos.responsabilidadSelected = resp;
            }
            if (this.montoacuerdo > 0) {
                const resp2 = this.montoacuerdo;
                this.datos.montoacuerdo = resp2;
            }



            let today = this.fechatoday;
            this.datos.fechanegociacion = today;
            this.fechaNeg = today;

            this.datos.observaciones = null;
            this.$refs.form.resetValidation();

        },
        ruleMoney: function ($event, value) {

            if (value == '' || value == null) {
                if ($event.charCode >= 49 && $event.charCode <= 57) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }
            }
            else {
                if (($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode == 46) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }

            }
        },
        cancelar() {
            if (this.push == 0) {
                this.push++;
                this.$router.go(-1);
            }

        },
        uppercase(input) {
            if (this.datos.observaciones != '' && this.datos.observaciones != null) {
                this.datos.observaciones = this.datos.observaciones.toUpperCase();
            }
        },
    },
    async mounted() {
        let validaConc = await MetodosGenerales.getReporteEstatus(this);
        if (validaConc == 2) { // si es 2 es porque esta cerrado
            this.validaConclusion = true;
        }

        let clavetercero = await MetodosGenerales.obtenerSessionReporte('reporte');
        if (clavetercero.d3id == undefined) {
            this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            return
        }



        this.changeReporteMenuOption(clavetercero.urlname);
        this.displayInputs = {
            nrreporte: clavetercero.nrreporte,
            svindice: clavetercero.svindice,
            d3id: clavetercero.d3id
        };

        await Reporte.obtenerEstatusListado(this).then(response => {
            if (this.validaConclusion
                || response.data[0].ConclusionDanosLes != 0
                || response.data[0].Estatus != 0
                || !response.data[0].permisoAltaNegociacion) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }

        });

        //let today = new Date().toJSON().slice(0, 10);
        //this.maxDate = today;
        //this.datos.fechanegociacion = today;
        //this.fechaNeg = today;

        await Reporte.obtenerDatosNegociacion(this).then(response => {
            this.maxDate = response.data[0].today;
            this.datos.fechanegociacion = response.data[0].today;
            this.fechaNeg = response.data[0].today;
            this.fechatoday = response.data[0].today;


            this.datos.responsabilidadname = response.data[0].svresponsable;
            this.datos.montoestimadodanos = response.data[0].svestdanosveh;
            this.minDate = response.data[0].svfhreporte;


            if (response.data[0].svperitaje2 != 0) {
                this.datos.responsabilidadSelected = response.data[0].svperitaje2;
                this.responsabilidadSelected = response.data[0].svperitaje2;
            }
            if (response.data[0].montoacuerdo > 0) {
                this.datos.montoacuerdo = response.data[0].montoacuerdo;
                this.montoacuerdo = response.data[0].montoacuerdo;
            }


        });

    }
}
</script>
<style>
.date-align-center .v-input input {
    text-align: center !important;
}
</style>
<style scoped>
.type-label-style {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 12px;
}

.type-text-style {
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 1.3em;
}
</style>